var _g, _rect, _g2, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgSuccess = function SvgSuccess(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3715_10140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.133,
    y: 2.133,
    width: 59.733,
    height: 59.733,
    rx: 29.867,
    fill: "url(#paint0_linear_3715_10140)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3715_10140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 59.733,
    height: 59.733,
    rx: 29.867,
    fill: "url(#paint1_linear_3715_10140)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3715_10140)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_3715_10140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.478 23.517c.696.637.696 1.75 0 2.387L29.78 39.483a1.66 1.66 0 0 1-2.408 0l-6.85-6.79a1.626 1.626 0 0 1 0-2.386 1.66 1.66 0 0 1 2.409 0l5.672 5.569L41.07 23.517a1.66 1.66 0 0 1 2.408 0Z",
    fill: "#7FD482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.281 39.971 13.681-13.56c.98-.91.984-2.478.01-3.391a2.36 2.36 0 0 0-3.404.009L28.6 34.893l-5.17-5.076a2.36 2.36 0 0 0-3.401-.008 2.326 2.326 0 0 0 .009 3.39l6.831 6.772a2.36 2.36 0 0 0 3.412 0Z",
    stroke: "#000",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3715_10140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.278,
    cy: 41.704,
    rx: 11.983,
    ry: 11.161,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3715_10140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.713,
    cy: 11.249,
    rx: 14.999,
    ry: 6.678,
    fill: "url(#paint2_linear_3715_10140)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.633,
    y: 2.633,
    width: 58.733,
    height: 58.733,
    rx: 29.367,
    stroke: "url(#paint3_linear_3715_10140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3715_10140",
    x1: 32,
    y1: 2.133,
    x2: 32,
    y2: 61.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3715_10140",
    x1: 31.867,
    y1: 2,
    x2: 31.867,
    y2: 61.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3715_10140",
    x1: 24.66,
    y1: 2.378,
    x2: 7.342,
    y2: 4.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3715_10140",
    x1: 32,
    y1: 2.133,
    x2: 32.001,
    y2: 61.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969292",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3715_10140",
    x: -3.867,
    y: -3.867,
    width: 71.733,
    height: 71.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3715_10140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_3715_10140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_3715_10140",
    x: 17.6,
    y: 21.1,
    width: 28.8,
    height: 21.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3715_10140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3715_10140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_3715_10140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3715_10140",
    x: 6.295,
    y: 4.543,
    width: 75.966,
    height: 74.322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3715_10140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3715_10140",
    x: -17.441,
    y: -11.585,
    width: 62.31,
    height: 45.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_3715_10140"
  })))));
};
export default SvgSuccess;